import useCurrentMerchant from 'hooks/useCurrentMerchant'

export type UseLiveUpdatesState = {
  isDisabled: boolean
}

export const useLiveUpdatesState = (): UseLiveUpdatesState => {
  const merchant = useCurrentMerchant()

  return { isDisabled: merchant?.live_updates_state === 'disabled' }
}

export default useLiveUpdatesState
